export const ALL_BELL_ALERTS = 'all_bellAlerts';
export const DELTA_NEWS = 'delta_news';
export const DELTA_OFFERING = 'delta_offering';
export const SYSTEM_UPDATES = 'system_updates';
export const ACTIVITIES = 'activities';
export const KYC_VERIFIED = 'kyc_verified';
export const DEPOSIT = 'deposit';
export const WITHDRAWAL = 'withdrawal';

export const BELL_ALERTS_CATEGORIES = {
  ALL_BELL_ALERTS,
  DELTA_NEWS,
  DELTA_OFFERING,
  SYSTEM_UPDATES,
  ACTIVITIES,
  KYC_VERIFIED,
  DEPOSIT,
  WITHDRAWAL,
} as const;

// Bell alert types

export const USER_BELL_ALERT = 'user_bell_alert';
export const COMMON_BELL_ALERT = 'common_bell_alert';

export const BELL_ALERT_TITLES = {
  WITHDRAWAL: {
    INITIATED: 'Withdrawal Initiated',
    SUCCESS: 'Withdrawal Success',
  },
} as const;
